import React, { useState } from 'react'
import { Checkbox, Popover, Radio } from 'antd'
import { FilterFilled } from '@ant-design/icons'

export interface ColumnFilterOption {
  label: string
  value: string
}

interface ColumnFilterProps {
  ariaLabel: string
  multiple?: boolean
  options: ColumnFilterOption[]
  value: string[]
  onChange: (value: string[]) => void
}

const ColumnFilter: React.FC<ColumnFilterProps> = ({
  ariaLabel,
  multiple = true,
  options,
  value,
  onChange,
}) => {
  const [open, setOpen] = useState(false)
  const active = value.length > 0

  const toggleValue = (next: string) => {
    if (!multiple) {
      onChange(value[0] === next ? [] : [next])
      return
    }
    onChange(value.includes(next) ? value.filter((item) => item !== next) : [...value, next])
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      arrow={false}
      open={open}
      onOpenChange={setOpen}
      overlayClassName="um-refactor__filter-popover"
      content={(
        <div
          className="um-refactor__filter-dropdown"
          role="listbox"
          aria-label={ariaLabel}
          aria-multiselectable={multiple}
          onMouseDown={(e) => e.preventDefault()}
        >
          {options.map((option) => {
            const checked = value.includes(option.value)
            return (
              <div
                key={option.value}
                className="um-refactor__filter-option"
                role="option"
                aria-selected={checked}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  toggleValue(option.value)
                }}
              >
                {multiple ? <Checkbox checked={checked} /> : <Radio checked={checked} />}
                <span className="um-refactor__filter-option-label" title={option.label}>
                  {option.label}
                </span>
              </div>
            )
          })}
        </div>
      )}
    >
      <button
        type="button"
        aria-label={ariaLabel}
        aria-expanded={open}
        className={[
          'um-refactor__filter-trigger',
          open ? 'um-refactor__filter-trigger--open' : '',
          active ? 'um-refactor__filter-trigger--active' : '',
        ].filter(Boolean).join(' ')}
      >
        <FilterFilled rev={undefined} />
      </button>
    </Popover>
  )
}

export default ColumnFilter
